import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Plus, Trash2 } from "lucide-react";

export function CvEditor({ content, setField, setLines, updateExp, updateEdu, removeExp, removeEdu, addExp, addEdu }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-md shadow-sm p-6 md:p-8 max-w-3xl mx-auto space-y-6">
      <section>
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Professional Title</p>
        <Input value={content.title} onChange={(e) => setField("title", e.target.value)} placeholder="e.g. Senior Backend Engineer | Cloud | APIs" data-testid="output-title" />
      </section>

      <section>
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Professional Summary</p>
        <Textarea rows={4} value={content.summary} onChange={(e) => setField("summary", e.target.value)} data-testid="output-summary" />
      </section>

      <section>
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Career Highlights (one per line)</p>
        <Textarea rows={3} value={(content.career_highlights || []).join("\n")} onChange={(e) => setLines("career_highlights", e.target.value)} data-testid="output-highlights" />
      </section>

      <section>
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Key Skills (comma separated)</p>
        <Textarea rows={2} value={content.skills.join(", ")} onChange={(e) => setField("skills", e.target.value.split(",").map((s) => s.trim()).filter(Boolean))} data-testid="output-skills" />
      </section>

      <section>
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Professional Experience</p>
          <Button variant="ghost" size="sm" onClick={addExp}><Plus className="h-4 w-4 mr-1" strokeWidth={1.5} /> Add</Button>
        </div>
        <div className="space-y-4">
          {content.experience.map((e, i) => (
            <div key={e._k || i} className="rounded-md border border-zinc-200 p-3 space-y-2" data-testid={`output-exp-${i}`}>
              <div className="grid grid-cols-2 gap-2">
                <Input value={e.role || ""} onChange={(ev) => updateExp(i, "role", ev.target.value)} placeholder="Role" />
                <Input value={e.company || ""} onChange={(ev) => updateExp(i, "company", ev.target.value)} placeholder="Company" />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <Input value={e.location || ""} onChange={(ev) => updateExp(i, "location", ev.target.value)} placeholder="Location" />
                <Input value={e.dates || ""} onChange={(ev) => updateExp(i, "dates", ev.target.value)} placeholder="Dates" />
              </div>
              <Textarea rows={4} value={(e.bullets || []).join("\n")} onChange={(ev) => updateExp(i, "bullets", ev.target.value.split("\n"))} placeholder="Achievement bullets (one per line)" />
              <div className="flex justify-end">
                <Button variant="ghost" size="sm" className="text-destructive" onClick={() => removeExp(i)}><Trash2 className="h-4 w-4 mr-1" strokeWidth={1.5} /> Remove</Button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Education</p>
          <Button variant="ghost" size="sm" onClick={addEdu}><Plus className="h-4 w-4 mr-1" strokeWidth={1.5} /> Add</Button>
        </div>
        <div className="space-y-4">
          {content.education.map((e, i) => (
            <div key={e._k || i} className="rounded-md border border-zinc-200 p-3 space-y-2" data-testid={`output-edu-${i}`}>
              <div className="grid grid-cols-2 gap-2">
                <Input value={e.degree || ""} onChange={(ev) => updateEdu(i, "degree", ev.target.value)} placeholder="Degree" />
                <Input value={e.institution || ""} onChange={(ev) => updateEdu(i, "institution", ev.target.value)} placeholder="Institution" />
              </div>
              <Input value={e.dates || ""} onChange={(ev) => updateEdu(i, "dates", ev.target.value)} placeholder="Dates" />
              <div className="flex justify-end">
                <Button variant="ghost" size="sm" className="text-destructive" onClick={() => removeEdu(i)}><Trash2 className="h-4 w-4 mr-1" strokeWidth={1.5} /> Remove</Button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Professional Development (one per line)</p>
        <Textarea rows={3} value={(content.professional_development || []).join("\n")} onChange={(e) => setLines("professional_development", e.target.value)} data-testid="output-profdev" />
      </section>
    </div>
  );
}
